import {SxProps, Theme} from '@mui/material';
import theme from '../../../../theme';
import {PHONE_TOUCH} from 'src/components/mobile/mobileDesign.sx';

/**
 * The card's own menu.
 *
 * It was 20x20: a target less than half the size of a fingertip, sitting in the corner of a card
 * people were expected to hit while scrolling. The glyph stays small; the square around it does not.
 */
export const iconSx: SxProps<Theme> = {
    width: PHONE_TOUCH,
    height: PHONE_TOUCH,
    borderRadius: '10px',
    backgroundColor: 'transparent',
    '&:hover': {
        backgroundColor: theme.palette.neutral[50],
    },
};
